export const moduleRoutes = {
  root: 'reversions',
  childForms: {
    reversionRequest: {
      data: { title: 'Anulación' },
      requireAuth: true,
      functions: [],
      route: 'solicitud',
    },
  },
  layout: 'main',
  loadChildren: () => import('src/app/pages/reversions/reversions.module').then(m => m.ReversionsModule),
};
